/**
 * Starts a download of the file at `url` (e.g. a rendered PDF), opening it in a new tab when the
 * browser can't download it directly. Does nothing for an empty url.
 */
export const downloadFromUrl = (url) => {
	if (!url) return;
	const a = document.createElement("a");
	a.href = url;
	a.target = "_blank";
	a.download = "";
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
};
